export default "__VITE_ASSET__9463b7c3__"